export default {
  title: 'Engineering',
  sections: {
    fields_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">Expertise</div>in construction, geomatics and planning',
            text2: 'Your Swiss engineering partner<br> with international production facilities',
            image: '/seu/latest-assets/seu_25.jpg',
          }
        },
      }
    },
    fields_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Engineering'
          }
        }
      }
    },
    fields_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_30.jpg',
          }
        }
      }
    },
    fields_text_section: {
      fields: {
        field_one: {
          value: {
            text: '<span class="text-highlight">Leading engineering group </span> in Switzerland'
          }
        },
        field_two: {
          value: {
            text: 'SEU combines visionary thinking<br> with the highest standards and<br> its own offshore production.'
          }
        },
        field_three: {
          value: {
            text: 'As a leading engineering partner, we have extensive resources in Switzerland with targeted support from international production facilities. They’re available to our partner companies for increased competitiveness in the areas of construction, geomatics and planning.'
          }
        },
      }
    },
    fields_feature_section: {
      fields: {
        field_one: {
          value: {
            boxes: [
              {
                image: '/seu/icon-mechanic.svg',
                mainTitle: 'Construction',
                subTitle: 'Quality in depth and expertise with foresight.',
                description: `We bring together the best of the Swiss engineering industry so we can combine efforts for greater efficiency and profitability.`,
                buttonLabel: 'Our strengths are',
                items: `
                <ul> <li>Construction, structural and civil engineering</li>
<li>Project management and development</li>
<li>Construction Supervision</li>
<li>Owner Support Services</li>
<li>BIM (Building Information Management)</li>
<li>Municipal Engineering</li>
 </ul>
                `,
              },
              {
                image: '/seu/icon-geomatic.svg',
                mainTitle: 'Geomatics',
                subTitle: 'Unflappably precise down to the smallest detail.',
                description: 'We’re experts, forward thinkers, specialists and innovators in all areas of geomatics. ',
                buttonLabel: 'Our strengths are',
                items: `
             <ul> <li>    Building surveys (architectural measurement, structural measurement) and building documentation </li>
<li>   3D models (BIM models, digital twins, as-built models)</li>
<li>   Land surveying</li>
<li>   Geospatial Information Systems</li>
<li>   Construction surveying, engineering surveying</li>
<li>   Geomatic surveying (geodetic, geotechnical, geomonitoring)</li>
<li>   Vibration measurement</li>
<li>   Preservation of evidence</li>
<li>   Tunnel surveying</li> </ul>
                `
              },
              {
                image: '/seu/icon-planning.svg',
                mainTitle: 'Planning',
                subTitle: 'Designing living spaces and directing supply flows.',
                description: 'We want to develop, create and build new living spaces together. We’re committed to thinking sustainably and implementing with precision',
                buttonLabel: 'Our strengths are',
                items: `
<ul> <li> Spatial development (structural planning, utilization planning, site planning, district planning)</li>
<li>Traffic planning (traffic management, traffic-calming, traffic safety, noise control) </li>
<li>Environmental planning (environmental sustainability, environmental construction support)</li>
<li>Energy and sustainability</li> </ul>
                  `
              },

            ]
          }
        },

      }
    }
  }
}
